import type { MouseEvent } from 'react';
import { useState } from 'react';

import useRequest from '@swf/core/hooks/useRequest';
import type {
  ChangePlayersStatusResponse,
  HGChangePlayersStatusReply
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse, useHomeGamesWidget } from '@swf/poker';

const useCancelJoinClub = (clubId: number) => {
  const { widgetDispatch } = useHomeGamesWidget();

  const request = useRequest();
  const [loading, setLoading] = useState(false);

  const handleCancel = (event: MouseEvent) => {
    event.preventDefault();
    setLoading(true);
    request({
      service: 'homeGames.cancelJoinClubRequest',
      body: { clubId }
    }).subscribe({
      next: ({ body }: { body: ChangePlayersStatusResponse }) => {
        const { error } = handleServerResponse<
          ChangePlayersStatusResponse,
          HGChangePlayersStatusReply
        >({
          response: body,
          accessor: 'changePlayersStatusReply'
        });
        setLoading(false);

        if (!error) {
          widgetDispatch.getUserClubs();
        }
      }
    });
  };

  return { handleCancel, loading };
};

export default useCancelJoinClub;
